<template>
	<div class="field">
		<label v-if="label" class="label">{{ label }}</label>
		<div class="control" :class="{ 'has-icons-left': hasIcon }">
			<money
				v-model="price"
				class="input"
				:class="{ 'is-danger': showError }"
				v-bind="money"
				:disabled="disabled"
				:data-test="name"
				@input="input"
				@blur="blur"
				@focus="focus"
			/>
			<span v-if="hasIcon" class="icon is-left">
				<dc-icon class="currency" :icon="icon" />
			</span>
		</div>
		<p v-if="showError" class="help is-danger" :data-test="`error-${name}`">
			{{ error }}
		</p>
		<slot />
	</div>
</template>

<script>
import fieldMixin from "@lab/utils/fieldMixin";
import { Money } from "v-money";
export default {
	components: { Money },
	mixins: [fieldMixin],
	props: {
		placeholder: {
			type: String,
			default: () => null
		},
		type: {
			type: String,
			default: () => "text"
		},
		label: {
			type: String,
			default: () => null
		},
		icon: {
			type: String,
			default: () => "dollar-sign"
		},
		precision: {
			type: Number,
			default: () => 0
		}
	},
	data() {
		return {
			money: {
				precision: this.precision,
				masked: false
			}
		};
	},
	computed: {
		hasIcon() {
			return this.icon;
		},
		price: {
			get() {
				return this.value ? this.value : "";
			},
			set() {}
		}
	}
};
</script>

<style scoped>
.currency >>> svg {
	position: absolute;
	left: 1em;
	top: 0.5em;
	color: #4a4a4a;
}
</style>
